import React from 'react';
import Icon from '../../mweb/Icon/Icon';
import './whatsapp-help.scss';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import {
  CC_WHATSAPP_LINK,
  WHATSAPP_HELP_TEXT,
} from 'hb-redux-store/constants/whatsappHelp';

const WhatsappHelp = props => {
  const size = getDeviceType() === DEVICE_TYPE.DESKTOP ? 50 : 30;
  return (
    <a
      href={CC_WHATSAPP_LINK}
      target="_blank"
      className="whatsapp-help--container"
    >
      <Icon class="icon-whatsapp-flat" size={size} />
      <div className="whatsapp-help--container--help-text">
        {WHATSAPP_HELP_TEXT}
      </div>
    </a>
  );
};

export default WhatsappHelp;
